import { useEffect } from 'react';
import { Step } from 'shared/InstallationDialog';
import { useMultiStepDialog } from 'shared/MultiStepDialog';
import { spawn } from 'utils/translations';
import { CodeBlock } from '../../CodeBlock';
import { AZURE_MASTER_APP_MANIFEST } from '../consts';

export const ReviewManifest = () => {
  const spawnStep = spawn('dialogs.azure-installation.steps.review-manifest');
  const { setIsNextEnabled } = useMultiStepDialog();

  useEffect(() => {
    setIsNextEnabled(true);
  }, []);

  const manifestJson = JSON.stringify(AZURE_MASTER_APP_MANIFEST, null, 2);

  return (
    <Step title={spawnStep('title')} description={spawnStep('description')}>
      <div className="max-h-115 overflow-auto">
        <CodeBlock
          rawCode={manifestJson}
          displayCode={manifestJson}
          copyTitle={spawnStep('copy-title')}
        />
      </div>
    </Step>
  );
};
